 <script setup>

import app from "@/core/app/app";
import {ref} from "vue";
import tx from "../../../core/app/tx";
import {ShuttleCalls} from "@/features/shuttle-calls/components/shuttle-calls";
import auth from "@/core/app/auth";
import ShuttleItem from "@/features/shuttle-calls/components/ShuttleItem.vue";

let containerVisible = ref(false);
let loading = ref(false);

function toggleVisible() {
  containerVisible.value = !containerVisible.value;
}

async function refresh() {
  loading.value = true;
  await ShuttleCalls.refresh();
  loading.value = false;

}

const isSuper = auth.isSuper();

</script>

<template>
  <button v-show="app.state.shuttleTimerSeconds==0" id="shuttle-shower"
          class="  orange button-silky "
          @click="toggleVisible"
  >
    <span class="icon fa fa-bus"></span> <span class="icon fa fa-clock-o"></span>
  </button>

  <button v-show="app.state.shuttleTimerSeconds>0" class="button orange " id="shuttle-notifier"
          @click="toggleVisible"
  >
    <span class="icon fa fa-bus"></span><span
      style="font-size:20px;font-weight: 800">{{ app.state.shuttleCallNum }}</span>
  </button>

  <div
      v-if="containerVisible"
      class="shuttle-overlay"
      @click="containerVisible = false"
  ></div>
  <div id="shuttle-calls-container" :class="{ 'is-open': containerVisible }"

  >
    <h3>Shuttle Calls</h3>
    <button   class="button-flat gray font-size-5 padding-s  closer " :title="tx.t('Close')"
            @click="containerVisible=false" type="button"><span class="ti-close"></span></button>
    <button    class="button-flat success font-size-5 padding-s  refresh " :title="tx.t('Refresh')"
            @click="refresh()" type="button"><span class="icon fa fa-refresh" :class="{'fa-spin':loading}"></span></button>
    <div class="flex align-items-center gap-m margin-b-m">
      <div class="font-600"> Actualizar auto cada:</div>

      <select class="select"
              :value="app.state.shuttleTimerSeconds"
              @change="e => app.setShuttleTimer(parseInt(e.target.value))"
      >
        <option value="0">Desactivado</option>
        <option v-if="isSuper" value="5">5 seg</option>
        <option v-if="isSuper" value="10">10 seg</option>
        <option value="60">1 minuto</option>
        <option value="120">2 minutos</option>
        <option value="180">3 minutos</option>
        <option value="240">4 minutos</option>
        <option value="300">5 minutos</option>
        <option value="600">10 minutos</option>
      </select>
    </div>

    <shuttle-item  v-for ="(item,index) in app.state.shuttleCalls" :key=" item.id" :call="item" >
      <div style="text-align: left">
        <button type='button' class="button secondary" @click="ShuttleCalls.ack(index)">{{tx.t("Visto")}}</button>
      </div>

    </shuttle-item>


  </div>
</template>
<style scoped>
#shuttle-notifier, #shuttle-shower {
  height: 36px;margin-top: 7px; line-height: 1;
  padding: 0 8px 0 8px; border-radius: 13px;
}
#shuttle-notifier { font-size: 20px; }
#shuttle-shower { font-size: 18px; }
#shuttle-calls-container {
  position: fixed;
  top: 50px;
  right: 0;
  bottom: 0;
  overflow: auto;
  width: 400px;
  background: #eee;
  border: #ccc solid 1px;
  padding: 16px;

  box-shadow: -5px 3px 10px rgba(0, 0, 0, 0.2);

  /* ESTADO INICIAL: Escondido a la derecha */
  transform: translateX(100%);
  opacity: 0;

  /* Transición suave */
  transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.3s ease;
  z-index: 10000;
  pointer-events: none;

  &.is-open {
    transform: translateX(0);
    opacity: 1;
    pointer-events: auto;
  }

  .closer {
    position: absolute;
    top: 10px;
    right: 10px;
  }

  .refresh {
    position: absolute;
    top: 9px;
    right: 50px;
  }
}
.shuttle-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.05); /* Un toque sutil de sombra */
  z-index: 9999; /* Justo debajo del panel (que tiene 10000) */
  cursor: default;
}
</style>